var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 186,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16B88E",
    d: "M60.334 75.535c-4.405-4.361-8.048-9.706-10.936-15.77-2.914-6.137-5.057-13.002-6.42-20.35-1.388-7.457-1.98-15.423-1.774-23.636l.034-1.493 1.397.072c3.12.164 6.523.01 9.977-.573 3.051-.52 6.145-1.375 9.128-2.659 2.494-1.074 4.894-2.44 7.105-4.133a30.455 30.455 0 0 0 5.623-5.61L75.53 0l1.062 1.384a30.685 30.685 0 0 0 5.614 5.609c2.212 1.693 4.62 3.059 7.106 4.133 2.982 1.284 6.076 2.14 9.128 2.659 3.454.583 6.856.737 9.976.573l1.397-.072.035 1.493c.205 8.213-.386 16.18-1.775 23.636-1.371 7.348-3.505 14.222-6.428 20.35-2.888 6.073-6.53 11.409-10.936 15.77-4.217 4.17-9.128 7.439-14.734 9.57h-.925c-5.606-2.14-10.517-5.4-14.734-9.57h.017Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m62.88 36.074 7.285 7.74a.834.834 0 0 0 1.235 0l16.773-17.82a.828.828 0 0 1 1.217 0l3.763 3.998a.959.959 0 0 1 0 1.293L71.39 54.402a.828.828 0 0 1-1.217 0L57.909 41.373a.959.959 0 0 1 0-1.293l3.763-3.997a.828.828 0 0 1 1.217 0l-.009-.009Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#F1CABE",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "m19.587 139.279 11.51 7.083c.07-.073.13-.136.19-.209l7.987-8.486c1.56-1.657 3.626-2.495 5.683-2.495s4.114.829 5.682 2.495c1.552 1.648 2.332 3.824 2.34 6.009 0 .21 0 .419-.017.629a7.66 7.66 0 0 1 2.7-.492c2.057 0 4.114.828 5.683 2.495 1.55 1.657 2.33 3.833 2.34 6.018 0 .446-.035.892-.095 1.329a7.823 7.823 0 0 1 1.963-.227c1.954 0 4.011.828 5.58 2.485 1.56 1.657 2.34 3.843 2.34 6.037 0 .246 0 .492-.026.737a7.726 7.726 0 0 1 2.52-.427c2.057 0 4.114.828 5.682 2.494.412.437.763.911 1.072 1.421.257.428.47.874.65 1.329l4.106 4.352.086.091c.086.082.163.164.257.282l1.166 1.23a5.217 5.217 0 0 0 3.737 1.666c1.354 0 2.7-.528 3.728-1.603 1.029-1.083 1.552-2.513 1.56-3.951.009-1.43-.488-2.868-1.5-3.961l-7.594-7.848c-.54-.565-.557-1.484-.025-2.058a1.314 1.314 0 0 1 1.945-.027l7.628 7.885c1.175 1.256 2.606 1.975 4.037 2.039 1.312.064 2.64-.446 3.763-1.621 1.003-1.056 1.526-2.44 1.56-3.833.034-1.384-.403-2.768-1.312-3.86l-7.773-8.04a1.521 1.521 0 0 1-.026-2.067 1.315 1.315 0 0 1 1.946-.027l7.799 8.076c1.38 1.484 2.923 2.741 4.483 3.287 1.397.255 2.897-.082 4.414-1.685a5.7 5.7 0 0 0 1.534-3.432 5.961 5.961 0 0 0-.823-3.615 165.026 165.026 0 0 0-17.373-16.179c-5.957-4.78-12.214-9.087-18.513-12.611a25.768 25.768 0 0 1-2.255-1.42c-.42-.282-.668-.455-.762-.474-.223-.036-.823.219-2.297.847l-.189.082c-3.103 1.32-3.677 2.668-4.74 5.19-.351.829-.745 1.775-1.328 2.959a18.74 18.74 0 0 1-1.406 2.386c-1.611 2.276-3.685 3.978-6.205 4.789-2.117.837-4.663.728-7.14-.647a10.31 10.31 0 0 1-1.568-1.056.44.44 0 0 1-.077-.064c-1.089-1.001-1.517-2.212-1.552-3.687-.034-1.229.223-2.577.549-4.143l.497-2.312c1.808-8.568 2.674-12.647 5.022-15.452 2.16-2.576 5.272-3.733 11.211-5.927l1.466-.546-1.431-.729c-1.029-.446-1.715-.628-2.4-.619-.737 0-1.62.219-2.957.565l-8.683 2.74c-1.285.401-2.262.701-3.23.92-.995.228-1.998.391-3.352.546l-7.114.811c-2.503.282-2.966 0-4.32-.82-.103-.064-.214-.127-.574-.337-.026-.018-.051-.027-.069-.045l-1.791-1.02-15.89 36.748h-.01Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#F1CABE",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M32.906 149.021s-.035.064-.06.091c-.669 1.084-.943 2.376-.832 3.633a5.754 5.754 0 0 0 1.517 3.414 5.138 5.138 0 0 0 3.737 1.63 5.138 5.138 0 0 0 3.737-1.63l8.125-8.631c.943-1.075 1.406-2.459 1.406-3.842 0-1.43-.514-2.859-1.543-3.943-1.028-1.083-2.382-1.63-3.736-1.63-1.355 0-2.709.547-3.737 1.63l-7.989 8.486a6.064 6.064 0 0 0-.351.401 4.238 4.238 0 0 0-.274.391Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    stroke: "#F1CABE",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "m51.925 148.375-8.125 8.631c-.943 1.074-1.405 2.449-1.405 3.833 0 1.43.514 2.859 1.542 3.952 0 0 .043.045.06.073a5.107 5.107 0 0 0 3.669 1.566c1.32 0 2.708-.547 3.737-1.63l8.125-8.632c.934-1.074 1.406-2.449 1.406-3.833a5.791 5.791 0 0 0-1.543-3.951 5.138 5.138 0 0 0-3.737-1.63 5.138 5.138 0 0 0-3.737 1.63l.008-.009Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "#F1CABE",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "m61.816 157.989-7.988 8.486c-1.029 1.093-1.543 2.531-1.543 3.97 0 1.438.514 2.877 1.543 3.97a5.074 5.074 0 0 0 3.728 1.629 5.14 5.14 0 0 0 3.737-1.629l8.125-8.632c.935-1.074 1.406-2.449 1.406-3.824 0-1.439-.514-2.877-1.543-3.961-1.028-1.092-2.382-1.639-3.737-1.639-1.354 0-2.708.547-3.736 1.639l.008-.009Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    stroke: "#F1CABE",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "m72.23 166.83-6.557 6.965c-.943 1.075-1.405 2.45-1.405 3.833 0 1.43.514 2.859 1.542 3.952a5.138 5.138 0 0 0 3.737 1.63 5.138 5.138 0 0 0 3.737-1.63l6.42-6.82a5.75 5.75 0 0 0 1.423-2.758 5.985 5.985 0 0 0-.215-3.178 6.272 6.272 0 0 0-.497-1.065 5.378 5.378 0 0 0-.711-.929 5.104 5.104 0 0 0-3.737-1.63c-1.354 0-2.709.547-3.737 1.63Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    stroke: "#F1CABE",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "m85.54 173.923-1.653-1.757c-.017.155-.052.3-.078.446a8.646 8.646 0 0 1-2.16 4.207l-4.096 4.352.445.473c1.046 1.102 2.426 1.694 3.806 1.721a4.978 4.978 0 0 0 3.703-1.548c.985-1.038 1.508-2.394 1.568-3.769.051-1.384-.36-2.768-1.26-3.861-.017-.018-.077-.082-.137-.136-.034-.037-.069-.064-.129-.128h-.008Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    stroke: "#F1CABE",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M102.347 130.684a166.45 166.45 0 0 1 17.039 15.779l11.845-6.811-15.873-36.702-.454.264c-1.852 1.074-2.803 1.63-3.977 1.876-1.252.264-2.46.1-4.988-.237-.9-.119 1.997.264-.995-.128-2.322-.309-4.457-.646-6.745-1.138a80.601 80.601 0 0 1-7.345-1.976c-1.012-.318-1.26-.4-1.509-.473-5.468-1.748-5.777-1.84-10.902.191-.849.337-1.346.537-1.569.619l-1.482.574a384.529 384.529 0 0 1-4.594 1.721c-5.494 2.03-8.366 3.095-10.063 5.117-1.885 2.249-2.69 6.091-4.396 14.149l-.49 2.313c-.29 1.365-.513 2.522-.488 3.423.018.637.18 1.147.583 1.539.377.3.755.546 1.14.755 1.757.975 3.566 1.057 5.237.465 1.74-.619 3.351-1.958 4.637-3.779.428-.61.823-1.274 1.174-1.985.497-1.001.9-1.966 1.26-2.804 1.363-3.214 2.091-4.944 6.223-6.692l.188-.082c1.963-.838 2.76-1.175 3.703-1.029.694.109 1.14.41 1.877.92.463.318 1.08.746 2.04 1.284 6.445 3.596 12.83 7.994 18.89 12.856l.034-.009Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m133.444 140.034 1.139 2.622 15.917-7.475-19.859-45.935-15.916 7.475 18.659 43.158c.025.045.042.1.06.145v.01Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M17.548 140.025s.034-.082.051-.119l16.962-39.233c.017-.045.034-.091.06-.136l1.646-3.797-15.917-7.475L.5 135.19l15.916 7.475 1.14-2.631-.008-.009Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 19.587,
    x2: 118.924,
    y1: 137.148,
    y2: 137.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1CABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9E1D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 31.989,
    x2: 50.528,
    y1: 147.956,
    y2: 147.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1CABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9E1D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 42.403,
    x2: 60.942,
    y1: 156.587,
    y2: 156.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1CABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9E1D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 52.294,
    x2: 70.833,
    y1: 166.193,
    y2: 166.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1CABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9E1D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 64.268,
    x2: 81.238,
    y1: 174.205,
    y2: 174.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1CABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9E1D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 77.544,
    x2: 87.067,
    y1: 177.775,
    y2: 177.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1CABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9E1D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 55.387,
    x2: 131.24,
    y1: 123.145,
    y2: 123.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1CABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9E1D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 114.716,
    x2: 150.491,
    y1: 115.96,
    y2: 115.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5A82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#45517A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2C3966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283562"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.5,
    x2: 36.275,
    y1: 115.96,
    y2: 115.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5EBDC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018189"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIllustration);
export default __webpack_public_path__ + "static/media/welcomeIllustration.7baeee60e9ea55b049ec3286322e07a9.svg";
export { ForwardRef as ReactComponent };